import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DirectSaleProgramGateway } from 'src/app/application/gateway/DirectSaleProgramGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { Exporter } from 'src/app/domain/models/Profile';
import { formatUrl } from 'src/app/ui/util/file-formats';

@Component({
  selector: 'app-admin-upload-programs',
  templateUrl: './admin-upload-programs.component.html',
  styleUrls: ['./admin-upload-programs.component.css'],
  providers: [ConfirmationService]
})
export class AdminUploadProgramsComponent implements OnInit{
excelFile: any;
  excelSheets: any;
  selectedSheet: string = '';
  loading: boolean = false;
  uploadFile: any[] = [];
  uploadFormatUrl: string = formatUrl.program_massive_create_format;
  uploadDisabled: boolean = true;
  enableUploadProgramButton: boolean = false;

  form: FormGroup = this._formBuilder.group({
    exporterUsername:[null, Validators.required]
  });

  constructor(
    private _messageService: MessageService,
    private translate: TranslateService,
    private _directSaleProgramService: DirectSaleProgramGateway,
    private _profileService: ProfileGateway,
    private _formBuilder: FormBuilder,
  ) {}

  exporters: Exporter[] = []

  ngOnInit(): void {
    this.getExporters()
  }

  sendFiles() {
    this.loading = true;
    console.log(this.form.value)
    if (this.uploadFile[0] && !this.form.invalid) {
      const request: any = {
        file: this.uploadFile[0],
        exporterUsername: this.form.controls['exporterUsername'].value
      };

      this._directSaleProgramService
        .uploadCreatePrograms(request)
        .subscribe({
          next: (v) => {
            this._messageService.add({
              severity: 'success',
              summary: this.translate.instant(
                'MessageService.Summary.SuccessAction'
              ),
              detail: 'Programas creados correctamente',
            });
            this.loading = false;
          },
          error: (e) => {
            this.loading = false;
            this._messageService.add({
              severity: 'error',
              summary: this.translate.instant(
                'MessageService.Summary.FailedAction'
              ),
              detail: e.error,
            });
          }
        });
    } else {
      this._messageService.add({
        severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.FailFileAction'),
      });
      this.loading = false;
    }
  }

  onSelect(event: any, uploader: any) {
    this.uploadFile = uploader.files;
    if (this.uploadFile.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }

  onRemove(event: any, uploader: any) {
    this.uploadFile = uploader.files;
    if (this.uploadFile.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }

  onClear(event: any, uploader: any) {
    this.uploadFile = uploader.files;
    if (this.uploadFile.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }

  getExporters() {
      this.exporters = []
      this.loading = true
      this._profileService.getAllExporters().subscribe({
        next: (v) => {
          this.exporters = v
          this.loading = false
        },
        error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.Exporter.ManyRetrieveError') })
        },
        complete: () => console.info('Importers query successfully')
      })

    }

onChangeExporter(){
    if(this.form.controls['exporterUsername'].value){
      this.enableUploadProgramButton = true;
    }else{
      this.enableUploadProgramButton = false;
    }
  }
}
